<script setup lang="ts">
import type { IconFonts } from "@/types";

interface Props {
    label?: string;
    type?: "outlined" | "raised" | "tertiary" | "tertiary__active";
    iconFont?: IconFonts;
    trailingIcon?: string;
    leadingIcon?: string;
}

const props = withDefaults(defineProps<Props>(), {
    iconFont: "ms",
});

function fontAwesomeIconClass(icon: string): string {
    return props.iconFont + " " + icon;
}
</script>

<template>
    <button
        class="mdc-button"
        :class="{
            'mdc-button--outlined': props.type === 'outlined',
            'mdc-button--raised': props.type === 'raised',
            'mdc-button--tertiary active': props.type === 'tertiary__active',
            'mdc-button--tertiary': props.type === 'tertiary',
            'mdc-button--icon-leading': props.leadingIcon,
            'mdc-button--icon-trailing': props.trailingIcon,
        }"
    >
        <i
            v-if="props.leadingIcon && props.iconFont === 'ms'"
            class="mdc-button__icon material-symbols-outlined"
            aria-hidden="true"
            v-text="props.leadingIcon"
        />
        <i
            v-if="props.leadingIcon && props.iconFont !== 'ms'"
            class="mdc-button__icon"
            :class="fontAwesomeIconClass(props.leadingIcon)"
            aria-hidden="true"
        />
        <span
            v-if="props.label"
            class="mdc-button__label"
            v-text="props.label"
        />
        <i
            v-if="props.trailingIcon && props.iconFont === 'ms'"
            class="mdc-button__icon material-symbols-outlined"
            aria-hidden="true"
            v-text="props.trailingIcon"
        />
        <i
            v-if="props.trailingIcon && props.iconFont !== 'ms'"
            class="mdc-button__icon"
            :class="fontAwesomeIconClass(props.trailingIcon)"
            aria-hidden="true"
        />
    </button>
</template>

<style scoped lang="scss">
.material-symbols-outlined {
    transform: translate(-21px, -11px);
    font-size: 42px;
}

.mdc-button--icon-leading,
.mdc-button--icon-trailing {
    padding-right: 12px;
    padding-left: 12px;
}
</style>
